export default __webpack_public_path__ + "static/media/card_3.ecdc22f7.svg";